// English strings (source language): activity detail.

const en = {
  notFound: 'Activity not found.',
  back: 'Back',
  backToList: '← Activities',
  rankOf: (rank: string, riders: number) => `${rank} of ${riders}`,
  workoutDone: 'workout completed',
  workoutStopped: 'workout stopped',
  /** Origin of the power data, flagged when it was not measured. */
  power: { virtual: 'estimated power', simulated: 'simulated power' },
  powerHelp: { virtual: 'Estimated from the wheel speed of a classic trainer.', simulated: 'Set with the keyboard, no sensor.' },
  compliance: (n: number) => `compliance ${n}%`,
  exportTcx: 'Export TCX',
  watchReplay: 'Watch the replay',
  delete: 'Delete',
  duration: 'Duration',
  distance: 'Distance',
  avgSpeed: 'Avg speed',
  elevation: 'Elevation',
  avgPower: 'Avg power',
  np: 'Normalized power',
  tssIf: (ifv: string) => `TSS · IF ${ifv}`,
  work: 'Work',
  maxPower: 'Max power',
  avgCad: 'Avg cadence',
  avgHr: (max: number) => `Avg HR${max ? ' · max ' + max : ''}`,
  xpGained: 'XP earned',
  curves: 'Charts',
  legendPower: 'power',
  legendHr: 'HR',
  legendCadence: 'cadence',
  zones: 'Time in zones',
  bests: 'Best efforts',
  colDuration: 'Duration',
  colPower: 'Power',
  noSamples: 'No samples for this activity',
  deleteConfirm: 'Delete this activity? XP already earned is kept.',
  stravaSend: 'Send to Strava',
  stravaPending: 'Sending to Strava…',
  stravaView: 'View on Strava',
  stravaFailed: 'Strava rejected the activity',
  shareOpen: 'Images to share',
  shareTitle: 'Images of this ride',
  shareHint: 'Save them, then add them to your ride on Strava or anywhere else. The scene is drawn by the game on the track you rode: it is not a capture of your race.',
  shareWorking: 'Drawing your images…',
  shareSave: 'Save',
  shareSend: 'Share',
  shareTagline: 'Your smart trainer turned into a game. Real training underneath.',
  shareClose: 'Close',
  shareFailed: 'Could not draw the images',
};
export default en;
